module.exports = __webpack_public_path__ + "img/1723083678637-kue keraton.jpg.451cf8b4.webp";